<div class="container-fluid my-2 px-0">
  <!-- Search Field -->
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ 'FLIGHT.SEARCH' | transloco }}</mat-label>
      <input matInput (keyup)="applyFilter($event)" [placeholder]="'FLIGHT.SEARCH_PLACEHOLDER' | transloco" #input>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <!-- Collapsible Filters -->
  <div class="filters-container">
    <div class="filters-header" (click)="toggleFilters()">
      <div class="filters-title">
        <mat-icon>filter_list</mat-icon>
        <span>{{ 'FLIGHT.FILTERS' | transloco }}</span>
      </div>
      <mat-icon class="expand-icon" [class.expanded]="filtersExpanded">expand_more</mat-icon>
    </div>

    <div class="filters-content" [class.expanded]="filtersExpanded">
      <form [formGroup]="departureForm">
        <div class="filters-grid">

          <!-- Date Range -->
          <div class="filter-group">
            <mat-form-field appearance="outline">
              <mat-label>{{'SHUTTLE_PLANNING_PAGE.DATE_RANGE' | transloco}}</mat-label>
              <mat-date-range-input [formGroup]="departureForm" [rangePicker]="dateRangePicker">
                <input matStartDate formControlName="dateFrom" placeholder="Datum från">
                <input matEndDate formControlName="dateTo" placeholder="Datum till">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <!-- Status Multi-Select -->
          <div class="filter-group multiple-select">
            <!-- <mat-label class="filter-label">{{ 'FLIGHT.STATUS_FILTER' | transloco }}</mat-label> -->
            <mat-form-field>
              <mat-select [placeholder]="'FLIGHT.STATUS_FILTER' | transloco" formControlName="statusFilter" multiple>
                @for (status of availableStatuses; track status) {
                  <mat-option [value]="status">
                    {{ status }}
                  </mat-option>
                }
              </mat-select>
              <!-- <mat-icon matSuffix>filter_list</mat-icon> -->
            </mat-form-field>
          </div>

          <!-- Flights with Shuttles Only -->
          <div class="form-group">
            <mat-form-field class="filter-group" appearance="outline">
              <mat-label class="filter-label">{{ 'FLIGHT.SHUTTLE_FILTER' | transloco }}</mat-label>
              <mat-select formControlName="shuttleFilter">
                <mat-option value="all">{{ 'FLIGHT.ALL_FLIGHTS' | transloco }}</mat-option>
                <mat-option value="withShuttles">{{ 'FLIGHT.FLIGHTS_WITH_SHUTTLES' | transloco }}</mat-option>
                <mat-option value="withoutShuttles">{{ 'FLIGHT.FLIGHTS_WITHOUT_SHUTTLES' | transloco }}</mat-option>
              </mat-select>
              <mat-icon matSuffix>airport_shuttle</mat-icon>
            </mat-form-field>
          </div>
        <!-- </div> -->

        <!-- Filter Actions -->
        <div class="filter-actions">
          <button mat-fab color="primary" [attr.aria-label]="'FLIGHT.REFRESH' | transloco" (click)="getDepartures()"
            [matTooltip]="'FLIGHT.REFRESH' | transloco">
            <mat-icon>refresh</mat-icon>
          </button>
          @if (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) || myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId))) {
            <button
              mat-fab color="primary" [attr.aria-label]="'FLIGHT.ADD' | transloco" (click)="createDeparture()"
              [matTooltip]="'FLIGHT.ADD' | transloco">
              <mat-icon>add</mat-icon>
            </button>
          }
          <button mat-stroked-button color="primary" (click)="clearFilters()">
            <mat-icon>clear</mat-icon>
            {{ 'FLIGHT.CLEAR_FILTERS' | transloco }}
          </button>
          <!-- <div class="last-updated" *ngIf="departuresLastUpdated">
          <span class="last-updated-text">
            Last updated: {{ departuresLastUpdated | date:'yyyy-MM-dd HH:mm' }}
          </span>
        </div> -->
      </div>

    </div>
  </form>
</div>
</div>

<!-- Results -->
<div class="results-section">
  <mat-paginator [pageSizeOptions]="[100, 150, 250]" showFirstLastButtons></mat-paginator>
  <div class="overflow-auto">
    <table mat-table matSort [dataSource]="dataSource" class="results-table mat-elevation-z2">

      <ng-container matColumnDef="stationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.STATION' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.stationName }} </td>
      </ng-container>

      <ng-container matColumnDef="terminalName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.TERMINAL' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.terminalName }} </td>
      </ng-container>

      <ng-container matColumnDef="departureCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.FLIGHT' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.departureCode }}</td>
      </ng-container>

      <ng-container matColumnDef="operator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.COMPANY' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.operator }}</td>
      </ng-container>

      <ng-container matColumnDef="gate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.GATE' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.gate }}</td>
      </ng-container>

      <ng-container matColumnDef="scheduledDeparture">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.SCHEDULED_DEPARTURE' | transloco }}
        </th>
        <td mat-cell *matCellDef="let departure"> {{ departure.scheduledDeparture | date: 'yyyy-MM-dd HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="orderShuttles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.ORDER_SHUTTLES' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.orderShuttles }}</td>
      </ng-container>

      <ng-container matColumnDef="estimatedDeparture">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.ESTIMATED_DEPARTURE' | transloco }}
        </th>
        <td mat-cell *matCellDef="let departure"> {{ departure.estimatedDeparture | date: 'yyyy-MM-dd HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="actualDeparture">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.ACTUAL_DEPARTURE' | transloco }}
        </th>
        <td mat-cell *matCellDef="let departure"> {{ departure.actualDeparture | date: 'yyyy-MM-dd HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="flightDepartureDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.FLIGHT_DEPARTED_DATE' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.flightDepartureDate | date: 'yyyy-MM-dd' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.STATUS' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.status }}</td>
      </ng-container>

      <ng-container matColumnDef="remarks">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.INFO' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.remarks }}</td>
      </ng-container>

      <ng-container matColumnDef="arrivalStation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.DESTINATION' | transloco }}</th>
        <td mat-cell *matCellDef="let departure"> {{ departure.arrivalStation }}</td>
      </ng-container>

      <ng-container matColumnDef="checkInStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.CHECK_IN_STATUS' | transloco }}
        </th>
        <td mat-cell *matCellDef="let departure"> {{ departure.checkInStatus }}</td>
      </ng-container>

      <ng-container matColumnDef="checkInDeskFrom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.CHECK_IN_DESK_FROM' | transloco }}
        </th>
        <td mat-cell *matCellDef="let departure"> {{ departure.checkInDeskFrom }}</td>
      </ng-container>

      <ng-container matColumnDef="checkInDeskTo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.DEPARTURE.CHECK_IN_DESK_TO' | transloco }}
        </th>
        <td mat-cell *matCellDef="let departure"> {{ departure.checkInDeskTo }}</td>
      </ng-container>

      <ng-container matColumnDef="updated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'FLIGHT.LAST_UPDATED' | transloco }}</th>
        <td mat-cell *matCellDef="let departure">
          {{ departure.updated | date: 'yyyy-MM-dd HH:mm' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let departure; columns: displayedColumns;" (click)="showSelected(departure)"
        class="clickable-row">
      </tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
          <div class="no-data-content">
            <mat-icon>search_off</mat-icon>
            <span>{{ 'ORDER_LIST.NO_MATCH' | transloco: { value: input.value } }}</span>
          </div>
        </td>
      </tr>

    </table>
  </div>
</div>
</div>